<template>
    <div>
        <div class="back-link">
            <router-link class="btn btn-primary" :to="{ name: 'login'}">Volver al inicio de sesión</router-link>
        </div>
        <div class="register-container">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-center m-b-md">
                        <h3>Cambia tu contraseña</h3>
                    </div>
                    <div class="hpanel">
                        <div class="panel-body">
                            <form action="#" id="loginForm">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label>Nueva contraseña</label>
                                        <custom-input tipo="password" :field="$v.form.newPassword"
                                                      placeholder="***********"/>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label>Repite nueva contraseña</label>
                                        <custom-input tipo="password" :field="$v.form.repeatPassword"
                                                      placeholder="***********"/>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <a class="btn btn-primary" @click="save">Guardar</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <strong>Travelcab</strong> &copy; 2021
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomInput from './common/CustomInput.vue'
    import {alphaNum, required, sameAs} from 'vuelidate/lib/validators'
    import UserService from '../services/UserService';
    import Alert from "../util/alert";
    import {AUTH_LOGOUT} from '../store/actions/auth'

    export default {
        props: ['token'],
        components: {
            CustomInput
        },
        data() {
            return {
                form: {
                    newPassword: null,
                    repeatPassword: null,
                }
            }
        },
        validations: {
            form: {
                newPassword: {required, alphaNum},
                repeatPassword: {required, sameAsPassword: sameAs('newPassword')},
            }
        },
        methods: {
            async save() {
                this.$v.$touch();
                if (this.$v.$error) return;
                const self = this;
                try {
                    await UserService.resetPassword(self.token, {password: self.form.newPassword});
                    Alert.mensajeExito("Contraseña actualizada, vuelva a iniciar sesión");
                    self.$store.dispatch(AUTH_LOGOUT).then(() => self.$router.push({name: 'login'}))
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue